import {
  httpRequest as sharedHttpRequest,
  type HttpMethod,
  type HttpRequestData,
  type HttpRequestParams,
  type ApiBaseType,
  type HttpRequestConfig,
  type ErrorResponse,
  type CustomAxiosError,
} from '@utils/httpClient';

// Re-export all types
export type {
  HttpMethod,
  HttpRequestData,
  HttpRequestParams,
  ApiBaseType,
  HttpRequestConfig,
  ErrorResponse,
  CustomAxiosError,
};

// Wrapper function that provides environment-specific URLs
export const httpRequest = <T>(config: HttpRequestConfig): Promise<T> => {
  return sharedHttpRequest<T>({
    ...config,
    baseUrls: {
      INTEGRATION: import.meta.env.VITE_INTEGRATION_URL,
      VOYCE: import.meta.env.VITE_VOYCE_URL,
      JAVA: import.meta.env.VITE_OPS_API_URL, // Default Java API URL
    },
  });
};
